'use strict';

export default class Updates {
  constructor($http, $q) {
    'ngInject';
    this._$http = $http;
    this._$q = $q;
  }

  query(config) {
    // Create the $http object for this request
    let request = {
      url: '/api/updates/all',
      method: 'GET',
    };

    if(config && (config.type || config.year)) {
      if(!config.type) {
        delete config.type;
      }
      if(!config.year) {
        delete config.year;
      }
      request.params = config;
    }

    if(config && config._id) {
      request.url = `/api/updates/${config._id}`;
    }

    return this._$http(request).then(res => res.data);
  }

  save(update) {
    let request = {};

    if(update._id) {
      request.url = `/api/updates/${update._id}`;
      request.method = 'PUT';
    } else {
      request.url = '/api/updates';
      request.method = 'POST';
    }

    request.data = update;

    return this._$http(request).then(res => res.data);
  }

  delete(update) {
    let request = {};

    request.url = `/api/updates/${update}`;
    request.method = 'DELETE';

    return this._$http(request).then(res => res.data);
  }
  //
  // manual(application) {
  //   let request = {};
  //
  //   request.url = `${this._appConfig.api}/applications/manual`;
  //   request.method = 'POST';
  //
  //   request.data = application;
  //
  //   return this._$http(request).then(res => res.data);
  // }
  //
  // note(application) {
  //   let request = {};
  //
  //   request.url = `${this._appConfig.api}/applications/note`;
  //   request.method = 'POST';
  //
  //   request.data = application;
  //
  //   return this._$http(request).then(res => res.data);
  // }
  //
  // wait(application) {
  //   let request = {};
  //
  //   request.url = `${this._appConfig.api}/applications/wait`;
  //   request.method = 'POST';
  //
  //   request.data = application;
  //
  //   return this._$http(request).then(res => res.data);
  // }
  //
  // payAndAccept(application) {
  //   let request = {};
  //
  //   request.url = `${this._appConfig.api}/applications/pay/${application._id}`;
  //   request.method = 'PUT';
  //
  //   request.data = application;
  //
  //   return this._$http(request).then(res => res.data);
  // }
  //
  // acceptSpecial(application) {
  //   let request = {};
  //
  //   request.url = `${this._appConfig.api}/applications/special/${application._id}`;
  //   request.method = 'PUT';
  //
  //   request.data = application;
  //
  //   return this._$http(request).then(res => res.data);
  // }
  //
  // refund(application) {
  //   let request = {};
  //
  //   request.url = `${this._appConfig.api}/applications/refund/${application._id}`;
  //   request.method = 'PUT';
  //
  //   request.data = application;
  //
  //   return this._$http(request).then(res => res.data);
  // }
  //
  // capture(application) {
  //   let request = {};
  //
  //   request.url = `${this._appConfig.api}/applications/accept/${application._id}`;
  //   request.method = 'PUT';
  //
  //   request.data = application;
  //
  //   return this._$http(request).then(res => res.data);
  // }
  //
  // stats() {
  //   let request = {
  //     url: `${this._appConfig.api}/applications/stats`,
  //     method: 'GET',
  //   };
  //   return this._$http(request).then(res => res.data);
  // }
  //
  // report() {
  //   let request = {
  //     url: `${this._appConfig.api}/applications/report`,
  //     method: 'GET',
  //   };
  //   return this._$http(request).then(res => res.data);
  // }

}



// WEBPACK FOOTER //
// ./client/components/services/updates.service.js